import { makeStyles, Theme, createStyles, Typography } from "@material-ui/core";
import React from "react";
import { WebCrawlingConfigDataRow } from "../../../../../types/config";
import {
  FileTypeToggleButton,
  ScheduleRenderComponent,
} from "../../../../../components";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      fontSize: "0.875rem",
      color: theme.palette.error.dark,
    },
  })
);

interface Props {
  rowData: WebCrawlingConfigDataRow;
}

/** ファイルタイプ/スケジュール表示コンポーネント */
export function FiletypeAndScheduleRenderComponent(props: Props) {
  const classes = useStyles();

  const { rowData } = props;

  // スケジュールコンポーネント
  let scheduleComponent;
  if (rowData.filetypeAndSchedule.schedule.length > 0) {
    // １件でも定義がある場合
    scheduleComponent = (
      <ScheduleRenderComponent
        schedule={rowData.filetypeAndSchedule.schedule}
        showIcon
      />
    );
  } else {
    scheduleComponent = (
      <Typography component="span" className={classes.typography}>
        未設定
      </Typography>
    );
  }

  //--------------------
  // コンポーネント
  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {/* ファイル種類 */}
      <div style={{ marginRight: "1rem" }}>
        <FileTypeToggleButton
          state={rowData.filetypeAndSchedule.filetype}
          disabled
        />
      </div>
      {/* スケジュール */}
      {scheduleComponent}
    </div>
  );
}
